/**
 * Color legend for multi-row keyword highlights. Shows one swatch per query
 * row (term → color), so a user can tell which AND/OR row a highlight came
 * from. Renders nothing for single-term searches (the classic amber needs no
 * legend). Shared by the results and compare views; the export/snapshot HTML
 * builds its own static equivalent.
 */
import type { ColoredTerm } from '../utils/highlightColors';

export default function HighlightLegend({
  terms,
  className = '',
}: {
  terms: ColoredTerm[];
  className?: string;
}) {
  if (terms.length < 2) return null;
  return (
    <div className={`flex flex-wrap items-center gap-x-3 gap-y-1.5 ${className}`}>
      <span className="text-xs font-medium text-slate-400">Matches:</span>
      {terms.map((t) => (
        <span key={t.term} className="inline-flex items-center gap-1.5 text-xs text-slate-600">
          <span
            className="inline-block h-3 w-3 shrink-0 rounded-sm ring-1 ring-slate-300"
            style={{ backgroundColor: t.color }}
          />
          <span className="max-w-[14rem] truncate">{t.term}</span>
        </span>
      ))}
    </div>
  );
}
